'use strict';

var UserUtils = require('../UserUtils');
var ChatUtils = require('../ChatUtils');
var TeamUtils = require('../TeamUtils');
var FirebaseUtils = require('../FirebaseUtils');

var InviteTeamMembers = {

  getSchema: function getSchema() {
    return {
      "definitions": {
        "team": {
          "type": "object",
          "properties": {
            "id": { "type": "string" },
            "displayName": { "type": "string" }
          },
          "required": ["id", "displayName"]
        },
        "user": {
          "type": "object",
          "properties": {
            "id": { "type": "string" },
            "displayName": { "type": "string" }
          },
          "required": ["id", "displayName"]
        },
        "userTeam": {
          "type": "object",
          "properties": {
            "role": { "type": "string" }
          },
          "required": ["role"]
        }
      },
      "properties": {
        "team": { "$ref": "#/definitions/team" },
        "user": { "$ref": "#/definitions/user" },
        "userTeam": { "$ref": "#/definitions/userTeam" }
      },
      "required": ["team", "user", "userTeam"]
    };
  },

  execute: function execute(fbApp, body, timestamp, callback) {
    var dbRef = fbApp.database().ref();
    // Create the list of members from the invitees list
    if (!body.invitees) {
      body.invitees = [];
    }
    var members = body.invitees.map(function (invitee) {
      return {
        userId: invitee.id,
        displayName: invitee.displayName,
        access: 'member'
      };
    });
    // Query team default rooms to add the new members
    return fbApp.database().ref('teams/' + body.team.id + '/rooms').once('value').then(function (roomsSnapshot) {
      var updates = {};
      var teamRooms = roomsSnapshot && roomsSnapshot.val();
      // Add the invitees to the default rooms
      Object.keys(teamRooms).forEach(function (roomId) {
        ChatUtils.addUsersToRoom(updates, timestamp, { id: roomId }, body.team, members);
        // Hello message on the General channel
        if (teamRooms[roomId].type === 'team_general' && body.helloMessage) {
          ChatUtils.sendTextMessage(updates, timestamp, { id: roomId }, body.user, {
            id: dbRef.child('rooms/' + roomId + '/messages').push().key,
            text: body.helloMessage
          });
        }
      });
      body.invitees.forEach(function (invitee) {
        // Add this user to the team
        TeamUtils.addUserToTeam(updates, timestamp, body.team, invitee, {
          role: '',
          access: 'invitee'
        });
        // Create the invite for this user
        TeamUtils.createTeamInvite(updates, timestamp, body.team, {
          id: body.user.id,
          displayName: body.user.displayName,
          role: body.userTeam.role
        }, invitee);
      });
      return updates;
    }).then(function (updates) {
      // Save to firebase
      FirebaseUtils.saveToFirebase(dbRef, updates, callback);
    });
  }

};

module.exports = InviteTeamMembers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/functions/InviteTeamMembers.js
// module id = 1031
// module chunks = 0